import React from 'react';
import { withTracking } from '../../../Services/Monitoring/ApplicationInsights';
import PairButton from '../../../SharedComponents/Button/PairButton';
import AppContainer from '../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../SharedComponents/Container/BodyContainer';
import CustomImg from '../../../SharedComponents/CustomImage/CustomImg';
import CustomDialog from '../../../SharedComponents/Dialog/CustomDialog';
import LegalDialog from '../../../SharedComponents/Dialog/Legal/LegalDialog';
import { LegalInfoType } from '../../../SharedComponents/Dialog/Legal/LegalDialogModel';
import Header from '../../../SharedComponents/Header/HeaderRefactor';
import CustomLink from '../../../SharedComponents/Link/CustomLink';
import useLoading from '../../../SharedComponents/Spinner/PageLoadSpinner';
import CustomTypography, {
    TypographyType,
} from '../../../SharedComponents/Typography/CustomTypography';
import { ConsentAnalyticHandler } from './ConsentAnalyticHandlerHook';
import './ConsentAnalyticPageStyle.scss';
import useConsentAnalyticResource from './ConsentAnalyticResourceHook';

export interface IConsentPageProps {
    useHandler: (setLoading: React.Dispatch<boolean>) => ConsentAnalyticHandler;
}

const ConsentAnalyticPage = (props: IConsentPageProps) => {
    const { useHandler } = props;
    const [loadingSpinner, setLoading, loading] = useLoading();

    const { showLegalInfo, onContinue, openHyperLinkPrivacy, closeDialog } =
        useHandler(setLoading);

    const {
        header,
        consentImage,
        title,
        consentAnalyticText,
        privacyLink,
        analyticDataConsentAgreement,
        yesButton,
        noButton,
    } = useConsentAnalyticResource();

    return loading ? (
        <>{loadingSpinner}</>
    ) : (
        <>
            <CustomDialog fullScreen open={showLegalInfo}>
                <LegalDialog
                    onClose={closeDialog}
                    type={LegalInfoType.PrivacyPolicy}
                />
            </CustomDialog>
            <AppContainer>
                <Header headerContent={header} />
                <BodyContainer>
                    <CustomImg
                        imgType="small"
                        src={consentImage.src}
                        alt={consentImage.alt}
                        id={consentImage.id}
                    />

                    <CustomTypography
                        textAlign="left"
                        type={TypographyType.notoSansBodyBig}
                        text={title.text}
                        id={title.id}
                        className={'consent-analytic-page-title'}
                    />

                    <CustomTypography
                        textAlign="left"
                        type={TypographyType.notoSansBody}
                        text={consentAnalyticText.text}
                        id={consentAnalyticText.id}
                    />

                    <CustomLink
                        id={privacyLink.id}
                        onClick={openHyperLinkPrivacy}
                        color="inherit"
                        className={'consent-page-privacy-link'}
                    >
                        {privacyLink.text}
                    </CustomLink>

                    <CustomTypography
                        textAlign="left"
                        type={TypographyType.notoSansBody}
                        text={analyticDataConsentAgreement.text}
                        id={analyticDataConsentAgreement.id}
                        className={'consent-analytic-page-agreement'}
                    />
                </BodyContainer>
                <PairButton
                    withLoading
                    sticky={false}
                    primaryButton={{
                        children: yesButton.label,
                        id: yesButton.id,
                        onClick: () => onContinue(true),
                    }}
                    secondaryButton={{
                        children: noButton.label,
                        id: noButton.id,
                        onClick: () => onContinue(false),
                    }}
                />
            </AppContainer>
        </>
    );
};

export default withTracking(ConsentAnalyticPage);
